import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ClusterInputState } from "@graylog/server-api";
import UserNotification from "util/UserNotification";
import { INPUT_STATES_QUERY_KEY } from "hooks/useInputsStates";
import i18n from "i18n";
const startInput = async ({ inputId }) => ClusterInputState.start(inputId);
const stopInput = async ({ inputId }) => ClusterInputState.stop(inputId);
const setupInput = async ({ inputId }) => ClusterInputState.setup(inputId);
const useInputStateMutations = (input) => {
  const queryClient = useQueryClient();
  const startMutation = useMutation({
    mutationFn: startInput,
    onError: (error) => {
      UserNotification.error(
        i18n.t("use_input_state_mutations_notifications.start_failed", { ns: "inputs", title: input.title, error }),
        i18n.t("use_input_state_mutations_notifications.start_failed_title", { ns: "inputs", title: input.title })
      );
    },
    onSuccess: () => {
      UserNotification.success(
        i18n.t("use_input_state_mutations_notifications.started_success", { ns: "inputs" }),
        i18n.t("use_input_state_mutations_notifications.success_title", { ns: "inputs" })
      );
      queryClient.invalidateQueries({ queryKey: INPUT_STATES_QUERY_KEY });
    }
  });
  const stopMutation = useMutation({
    mutationFn: stopInput,
    onError: (error) => {
      UserNotification.error(
        i18n.t("use_input_state_mutations_notifications.stop_failed", { ns: "inputs", title: input.title, error }),
        i18n.t("use_input_state_mutations_notifications.stop_failed_title", { ns: "inputs", title: input.title })
      );
    },
    onSuccess: () => {
      UserNotification.success(
        i18n.t("use_input_state_mutations_notifications.stopped_success", { ns: "inputs" }),
        i18n.t("use_input_state_mutations_notifications.success_title", { ns: "inputs" })
      );
      queryClient.invalidateQueries({ queryKey: INPUT_STATES_QUERY_KEY });
    }
  });
  const setupMutation = useMutation({
    mutationFn: setupInput,
    onError: (error) => {
      UserNotification.error(
        i18n.t("use_input_state_mutations_notifications.setup_failed", { ns: "inputs", title: input.title, error }),
        i18n.t("use_input_state_mutations_notifications.setup_failed_title", { ns: "inputs", title: input.title })
      );
    },
    onSuccess: () => {
      UserNotification.success(
        i18n.t("use_input_state_mutations_notifications.deleted_success", { ns: "inputs" }),
        i18n.t("use_input_state_mutations_notifications.success_title", { ns: "inputs" })
      );
      queryClient.invalidateQueries({ queryKey: INPUT_STATES_QUERY_KEY });
    }
  });
  return {
    startInput: startMutation.mutateAsync,
    stopInput: stopMutation.mutateAsync,
    setupInput: setupMutation.mutateAsync
  };
};
export default useInputStateMutations;
